import { Component, inject } from '@angular/core';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { ServiceNotificationsService } from '../service-notifications.service';
import { AsyncPipe, NgIf } from '@angular/common';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';
import { Store } from '@ngrx/store';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { filter, tap } from 'rxjs/operators';

@Component({
    selector: 'brightside-web-service-notifications-menu',
    imports: [
        BrightsideUiModule,
        TranslateModule,
        RouterLink,
        LottieComponent,
        RouterLinkActive,
        NgIf,
        AsyncPipe,
        SharedDesktopModule,
    ],
    templateUrl: './service-notifications-menu.component.html',
    styleUrl: './service-notifications-menu.component.scss'
})
export class ServiceNotificationsMenuComponent {
  notificationOptions: AnimationOptions = {
    path: './assets/animation/bell.json',
    loop: true,
    autoplay: true,
  };

  private _serviceInventory = inject(ServiceInventoryService);
  private _serviceNotifications = inject(ServiceNotificationsService);
  hasUnread$ = this._serviceNotifications.hasUnreadNotifications$();
  protected displayMenuButton: boolean;

  constructor() {
    this._serviceInventory.getService('notifications')
      .pipe(
        filter((service) => !!service),
        tap((service) => {
          switch (service.state) {
            case ServiceState.MAINTENANCE:
              this.displayMenuButton = false;
              break;
            default:
              this.displayMenuButton = true;
              break;
          }
        })
      )
      .subscribe();
  }

}
